<template>
  <VPopup
    position="bottom"
    show-pointer
    class="change-bid-popup"
    :visible="true"
    :target="target"
  >
    <VForm ref="form">
      <PriceDescription
        :order-option="localBid"
        entity-type="bid"
        :best-bid="bestBid"
      />

      <div class="buttons-group">
        <VButton
          type="submit"
          theme="primary"
          @click="saveNewPrice"
        >
          Сохранить
        </VButton>
        <VButton @click="close">
          Отмена
        </VButton>
      </div>
    </VForm>
  </VPopup>
</template>

<style lang="scss" src="./TenderBidChangePopup.scss"/>

<script lang="ts">
import PriceDescription  from '@/domains/TenderBids/components/PriceDescription/PriceDescription.vue';
import TenderBid         from '@/domains/TenderBids/TenderBid';
import TenderBidsService from '@/domains/TenderBids/TenderBidsService';

export default defineComponent({
  name: 'TenderChangeBidPopup',

  components: { PriceDescription },

  props: {
    /** Ставка текущего партнёра — её цену и понижаем. */
    bid: {
      type:     Object as PropType<TenderBid>,
      required: true,
    },
    /** Лидирующая ставка: показывается как ориентир, на что целиться. */
    bestBid: {
      type:    Object as PropType<TenderBid>,
      default: null,
    },
    target: {
      type:    HTMLElement,
      default: null,
    },
  },

  data() {
    return {
      /** Клон: пользователь может закрыть попап, и правки не утекут в оригинал. */
      localBid: this.$core.utils.cloneDeep(this.bid),
    };
  },

  methods: {
    async saveNewPrice(): Promise<void> {
      await this.$refs.form.validate();

      if (this.$refs.form.isValid === false) return;

      if (await TenderBidsService.updateBid(this.localBid)) {
        this.$core.dialogs.TenderChangeBidPopup.resolve()
      }
    },

    close(): void {
      this.$core.dialogs.TenderChangeBidPopup.hide();
    },
  },
});
</script>
